import React from "react";
import "./Loading.scss";
class Loading extends React.Component {
  render() {
    return (
      <div className="loading-wrapper">
        <div className="circle-container">
          {[...Array(6)].map((_, i) => (
            <div key={i} className={`circle circle-${i + 1}`}></div>
          ))}
        </div>
        <div className="card">
          <div className="card-side"></div>
          <div className="card-side back"></div>
        </div>
      </div>
    );
  }
}

export default Loading;
